var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "system-user-list" },
    [
      _c("div", { staticClass: "page-title bottom-line" }, [
        _vm._v(" " + _vm._s(_vm.$t("menu.notifications")) + " "),
      ]),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("span", { staticClass: "transTime" }, [
            _vm._v(_vm._s(_vm.$t("no_auth.notification_time")) + ":"),
          ]),
          _c("el-date-picker", {
            staticClass: "picker",
            attrs: {
              size: "small",
              format: "yyyy-MM-dd",
              "value-format": "yyyy-MM-dd",
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": _vm.$t("components.start_date"),
              "end-placeholder": _vm.$t("components.end_date"),
            },
            model: {
              value: _vm.search.notice_time,
              callback: function ($$v) {
                _vm.$set(_vm.search, "notice_time", $$v)
              },
              expression: "search.notice_time",
            },
          }),
          _c(
            "el-select",
            {
              staticClass: "search-frame",
              attrs: {
                placeholder: _vm.$t("no_auth.type"),
                size: "small",
                clearable: "",
              },
              model: {
                value: _vm.search.template_type,
                callback: function ($$v) {
                  _vm.$set(_vm.search, "template_type", $$v)
                },
                expression: "search.template_type",
              },
            },
            _vm._l(_vm.templateTypeList, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
          _c("el-input", {
            staticClass: "search-frame",
            attrs: {
              placeholder: _vm.$t("no_auth.subject"),
              size: "small",
              clearable: "",
            },
            model: {
              value: _vm.search.title,
              callback: function ($$v) {
                _vm.$set(_vm.search, "title", $$v)
              },
              expression: "search.title",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "search-btn",
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleSearch },
            },
            [_vm._v(_vm._s(_vm.$t("components.search")))]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.resetSearch } },
            [_vm._v(_vm._s(_vm.$t("components.re_set")))]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "tabs-container" }, [
        _c("div", { staticClass: "tabs-left" }, [
          _c(
            "div",
            {
              staticClass: "tab-item",
              class: { active: _vm.activeTab === "unread" },
              on: {
                click: function ($event) {
                  return _vm.onTabChange("unread")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("no_auth.unread")) + " ")]
          ),
          _c(
            "div",
            {
              staticClass: "tab-item",
              class: { active: _vm.activeTab === "all" },
              on: {
                click: function ($event) {
                  return _vm.onTabChange("all")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("no_auth.all")) + " ")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "tabs-right" },
          [
            _vm.isAgentMerchant
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "success", size: "small" },
                    on: { click: _vm.showNotificationConfigModal },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("system.notification_config")) + " "
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.onClickMarkAllAsRead },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("no_auth.mark_all_read", {
                        count: _vm.$store.getters.unreadNotificaionCount,
                      })
                    ) +
                    " "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: _vm.$t("no_auth.subject"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: scope.row.title,
                              placement: "top",
                              disabled: !scope.row.title,
                            },
                          },
                          [
                            _c("div", { staticClass: "title-cell" }, [
                              scope.row.user_read_status === 1
                                ? _c("span", { staticClass: "dot" })
                                : _vm._e(),
                              _c("span", { staticClass: "title-text" }, [
                                _vm._v(_vm._s(scope.row.title)),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("no_auth.type"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getTemplateTypeLabel(scope.row.template_type)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("no_auth.notification_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.notice_actual_time) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.operation"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.detail"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function",
                                "icon-class": "operation-detail",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailBtn(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("NotificationConfigModalGlobal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }